import { Component, Input, OnInit } from '@angular/core';
import { NoteSection } from 'src/app/model/section/note-section';

@Component({
  selector: 'app-home-page-announcements-section',
  templateUrl: './home-page-announcements-section.component.html',
  styleUrls: ['./home-page-announcements-section.component.scss']
})
export class HomePageAnnouncementsSectionComponent implements OnInit {
  @Input() noteSections: NoteSection[] = [];
  constructor() {}

  ngOnInit(): void {}
}
